import { createSlice } from "@reduxjs/toolkit";
import SettingsType from "../Components/Pages/CommonSettings/Tabs/SettingsType";
const eses = require("../assets/Language/es-es.json");
const frfr = require("../assets/Language/fr-fr.json");
const ptpt = require("../assets/Language/pt-pt.json");
const itit = require("../assets/Language/it-it.json");
const dadk = require("../assets/Language/da-dk.json");
const dede = require("../assets/Language/de-de.json");
const nlnl = require("../assets/Language/nl-nl.json");
const jajp = require("../assets/Language/ja-jp.json");
const enus = require("../assets/Language/en-us.json");

export const languageSlice = createSlice({
  name: "counter",
  initialState: {
    LstLanguageCodes: enus,
    Language: "en-us",
  },
  reducers: {
    languageChange: (state, val) => {
      //console.log(val.payload);
      state.Language = val.payload;
      switch (val.payload) {
        case "da-dk":
          state.LstLanguageCodes = dadk;
          return;
        case "nl-nl":
          state.LstLanguageCodes = nlnl;
          return;
        case "fr-fr":
          state.LstLanguageCodes = frfr;
          return;
        case "de-de":
          state.LstLanguageCodes = dede;
          return;
        case "it-it":
          state.LstLanguageCodes = itit;
          return;
        case "pt-pt":
          state.LstLanguageCodes = ptpt;
          return;
        case "es-es":
          state.LstLanguageCodes = eses;
          return;
        case "ja-jp":
          state.LstLanguageCodes = jajp;
          return;
        default:
          state.LstLanguageCodes = enus;
          localStorage.setItem("language", "en-us");
          return;
      }
    },
  },
});
export const pageLevelRestrictionSlice = createSlice({
  name: "pageLevelRestrictionData",
  initialState: {
    onConfirm: false,
    pageLevelRestrictionData: [],
    authorizedReaders: [],
  },
  reducers: {
    retainConfiguredData(state, action) {
      state.onConfirm = action.payload.isConfirm;
      state.pageLevelRestrictionData = action.payload.pageRestrictionData;
      state.authorizedReaders = action.payload.authorizedReaders;
    },
    removeConfiguredData(state) {
      state.onConfirm = false;
      state.pageLevelRestrictionData = [];
      state.authorizedReaders = [];
    },
  },
});

export const timeZoneSlice = createSlice({
  name: "timeZoneData",
  initialState: {
    timeZoneObj: null,
    timeZoneAbbrevation: "UTC",   // ✅ added (same spelling)
    timeZoneOffset: "+00:00",     // ❌ unchanged
  },
  reducers: {
    retainTimeZoneData(state, action) {
      const tzObj = action.payload;
      state.timeZoneObj = tzObj;

      // ✅ existing offset logic (unchanged)
      const offsetMatch = tzObj?.keyValue?.match(/([+-]\d{2}:\d{2})/);
      state.timeZoneOffset = offsetMatch?.[1] ?? "+00:00";

      // ✅ NEW abbreviation logic
      const abbrMatch = tzObj?.keyValue?.match(/_(.*)$/);
      state.timeZoneAbbrevation = abbrMatch?.[1] ?? "UTC";
    },

    removeTimeZoneData(state) {
      state.timeZoneObj = null;
      state.timeZoneAbbrevation = "UTC";
      state.timeZoneOffset = "+00:00";
    },
  },
});

export const idLeakersSlice = createSlice({
  name: "idLeakers",
  initialState: {
    idLeakersType: "",
  },
  reducers: {
    setIDLeakersType: (state, action) => {
      state.idLeakersType = action.payload;
    },
    clearIDLeakersType: (state) => {
      state.idLeakersType = null;
    },
  },
});
export const DocumentTemplatesSlice = createSlice({
  name: "DocumentTemplates",
  initialState: {
    docTemplateOptions: "",
  },
  reducers: {
    setDocumentTemplates: (state, action) => {
      state.docTemplateOptions = action.payload;
    },
    clearDocumentTemplates: (state) => {
      state.docTemplateOptions = null;
    },
  },
});
export const CustomFilterOptionsSlice = createSlice({
  name: "customFilterOptions",
  initialState: {
    customFilterOptions: "",
  },
  reducers: {
    setCustomFilterOptions: (state, action) => {
      state.customFilterOptions = action.payload;
    },
    clearCustomFilterOptions: (state) => {
      state.customFilterOptions = null;
    },
  },
});
export const DocumentTemplateNameSlice = createSlice({
  name: "DocumentTemplateName",
  initialState: {
    docTemplateOptions: "",
  },
  reducers: {
    setDocumentTemplateName: (state, action) => {
      state.docTemplateName = action.payload;
    },
    clearDocumentTemplateName: (state) => {
      state.docTemplateName = null;
    },
  },
});


export const IdentifyLeakerSlice = createSlice({
  name: 'IdentifyLeakers',
  initialState: {
    cipherText: [],
    floatingText: [],
    lookupData: {},
  },
  reducers: {
    storeIdentifyLeakers(state, action) {
      state.cipherText = action.payload.cipherText;
      state.floatingText = action.payload.floatingText;
    },
    storeIDLeakerLookupData(state, action) {
      state.lookupData = action.payload.value;
    },
    updateIDLeakerValue(state, action) {
      const { type, value, level } = action.payload;
      const targetArray = level === 'CipherText' ? state.cipherText : state.floatingText;
      const item = targetArray.find(item => item.type === type);

      if (item) {
        item.keyValue = value;
      }
    },
    resetIdentifyLeakers(state) {
      state.cipherText = [];
      state.floatingText = [];
      state.lookupData = {};
    }
  }
})
export const TemplateIdentifyLeakerSlice = createSlice({
  name: "TemplateIdentifyLeakers",
  initialState: {
    cipherText: [],
    floatingText: [],
    lookupData: {}
  },
  reducers: {
    storeTemplateIdentifyLeakers(state, action) {
      state.cipherText = action.payload.cipherText;
      state.floatingText = action.payload.floatingText;
    },

    storeTemplateIDLeakerLookupData(state, action) {
      state.lookupData = action.payload.value;
    },

    updateTemplateIDLeakerValue(state, action) {
      const { type, value, level } = action.payload;

      const targetArray =
        level === "CipherText" ? state.cipherText : state.floatingText;

      const item = targetArray.find(item => item.type === type);

      if (item) {
        item.keyValue = value;
      }
    },

    resetTemplateIdentifyLeakers(state) {
      state.cipherText = [];
      state.floatingText = [];
      state.lookupData = {};
    }
  }
});




export const handleTabValuesSlice = createSlice({
  name: "handleTabValues",
  initialState: {
    tabValues: "false",
  },
  reducers: {
    sethandleTabValues(state, action) {
      state.tabValues = action.payload;
    },
  },
});



export const SettingsSlice = createSlice({
  name: "Settings",
  initialState: {
    lookupData: {},
    defaultSetting: 'Gateway',
    settingFor: '',
    searchedUser: '',
    searchedCompany: '',
    inValidInputs: [{
      ipAddress: false
    }],
    restoreDefaults: {
      cipher: false,
      floating: false,
      l1: false,
      l2: false,
      l3: false,
    },
    excludeControls: [],
    companyTab: {
      selectedTab: "",
      settingsData: [],
    },
    personalTab: {
      selectedTab: "",
      settingsData: [],
    },
    AdminTab: {
      selectedTab: "",
      settingsData: [],
    }
  },
  reducers: {
    storeSettingsData(state, action) {
      const { outerTabSelected, innerTabSelected, Settings, restoreDefaultSettings, } = action.payload;
      const tabMap = {
        'Personal': 'personalTab',
        'Company': 'companyTab',
        'Admin': 'AdminTab'
      };

      const tabKey = tabMap[outerTabSelected];
      if (tabKey) {
        state[tabKey].selectedTab = innerTabSelected;
        state[tabKey].settingsData = Settings;
      }
      if (innerTabSelected === "ContentSecurity") {
        if (restoreDefaultSettings && restoreDefaultSettings.cipher)
          state.restoreDefaults.cipher = restoreDefaultSettings.cipher
        else if (restoreDefaultSettings && restoreDefaultSettings.floating)
          state.restoreDefaults.floating = restoreDefaultSettings.floating
      } else if (innerTabSelected === "DirectSendDefaults") {
        if (restoreDefaultSettings && restoreDefaultSettings.l1)
          state.restoreDefaults.l1 = restoreDefaultSettings.l1
        else if (restoreDefaultSettings && restoreDefaultSettings.l2)
          state.restoreDefaults.l2 = restoreDefaultSettings.l2
        else if (restoreDefaultSettings && restoreDefaultSettings.l3)
          state.restoreDefaults.l3 = restoreDefaultSettings.l3
      }

    },
    updateSettingsData(state, action) {
      const { type, value, outerTabSelected, level, isOverride, isLock, securityLevel } = action.payload;
      if (state.restoreDefaults.cipher || state.restoreDefaults.floating || state.restoreDefaults.l1 || state.restoreDefaults.l2 || state.restoreDefaults.l3) {
        state.restoreDefaults.cipher = false;
        state.restoreDefaults.floating = false;
        state.restoreDefaults.l1 = false;
        state.restoreDefaults.l2 = false;
        state.restoreDefaults.l3 = false;
      }
      const tabMap = {
        'Personal': 'personalTab',
        'Company': 'companyTab',
        'Admin': 'AdminTab'
      };
      const levelMap = {
        common: "commonSettings",
        commonContentSecuritySetting: "commonContentSecuritySetting",
        l1: "l1",
        l2: "l2",
        l3: "l3",
        cipherText: 'cipherText',
        floatingText: 'floatingText'
      };

      const targetLevel = levelMap[level];
      if (!targetLevel) return;

      const tabKey = tabMap[outerTabSelected];
      const selectedTab = state[tabKey].selectedTab;

      let settings = [];
      if (selectedTab === "DirectSendDefaults") {
        const getDefaultSetting = state.defaultSetting;
        settings = [...state[tabKey].settingsData.find(s => s.settingFor === getDefaultSetting)[targetLevel]];
      } else if (selectedTab === "ContentSecurity") {
        settings = [...state[tabKey].settingsData[0]?.[targetLevel]];
      } else if (selectedTab === "Storage") {
        settings = [...state[tabKey].settingsData]
      } else {
        settings = [...state[tabKey].settingsData];
      }


      const tabSettingsTypes = SettingsType[selectedTab === "Advanced" ? "Advance" : selectedTab];

      if (type === "SelectAll" && isOverride) {
        let allSettings = [];
        let excludeOptions = ["ImageResolution", "MaxPagesPerRPD", "DirectSendDefaults", 'ContentSecurity', 'DateControlFormat', 'ExcelSupport', "RPDLite"]
        if (selectedTab === "DirectSendDefaults" || selectedTab === "ContentSecurity") {
          allSettings = [...settings];
        } else {
          allSettings = [...settings.filter(s => tabSettingsTypes.includes(s.type))];
          // let preventOverrideForShareVotes = allSettings.some((s)=> s.type === "Voting" && s.keyValue === "false");
          // if(preventOverrideForShareVotes){
          //   excludeOptions.push("ShareVotes");
          // }
        }
        let preventOverrideForShareVotes = allSettings.some((s) => s.type === "Voting" && s.keyValue === "false");
        if (preventOverrideForShareVotes) {
          excludeOptions.push("ShareVotes");
        }
        let preventOverrideForShape = allSettings.some((s) => s.type === "CipherPattern" && s.keyValue !== "2");
        if (preventOverrideForShape) {
          excludeOptions.push("Shape");
        }
        const overridenSettings = allSettings.map((s) => {
          return {
            ...s,
            [selectedTab === "DirectSendDefaults" || selectedTab === "ContentSecurity" || selectedTab === "ExcelSupport" ? "isOverride" : "overrideUserSetting"]: ((!excludeOptions.includes(s.type))) ? isOverride : "false",
            isDataChanged: (
              (s?.prevValue !== value) ||
              (s?.prevOverride !== isOverride) ||
              (s?.prevLock !== isLock)
            ),
          };
        });
        if (selectedTab === "DirectSendDefaults") {
          state[tabKey].settingsData.find(s => s.settingFor === state.defaultSetting)[targetLevel] = overridenSettings;
        }
        else if (selectedTab === "ContentSecurity") {
          state[tabKey].settingsData[0][targetLevel] = overridenSettings;
        } else {
          state[tabKey].settingsData = overridenSettings;
        }
        return;
      } else if (type === "SelectAll" && isLock) {
        let allSettings = [];
        let excludeOptions = ["DirectSendDefaults", 'ContentSecurity', 'DateControlFormat', 'ExcelSupport', "RPDLite"]
        if (selectedTab === "DirectSendDefaults" || selectedTab === "ContentSecurity") {
          allSettings = [...settings];
        } else {
          allSettings = [...settings.filter(s => tabSettingsTypes.includes(s.type))];
        }
        let preventOverrideForShareVotes = allSettings.some((s) => s.type === "Voting" && s.keyValue === "false");
        if (preventOverrideForShareVotes) {
          excludeOptions.push("ShareVotes");
        }
        let preventOverrideForShape = allSettings.some((s) => s.type === "CipherPattern" && s.keyValue !== "2");
        if (preventOverrideForShape) {
          excludeOptions.push("Shape");
        }
        const lockedSettings = allSettings.map((s) => {
          return {
            ...s,
            [selectedTab === "DirectSendDefaults" || selectedTab === "ContentSecurity" ? "isLock" : "lockSetting"]: ((!excludeOptions.includes(s.type))) ? isLock : "false",
            isDataChanged: (
              (s?.prevValue !== value) ||
              (s?.prevOverride !== isOverride) ||
              (s?.prevLock !== isLock)
            )
          };
        });
        if (selectedTab === "DirectSendDefaults") {
          state[tabKey].settingsData.find(s => s.settingFor === state.defaultSetting)[targetLevel] = lockedSettings;
        }
        else if (selectedTab === "ContentSecurity") {
          state[tabKey].settingsData[0][targetLevel] = lockedSettings;
        } else {
          state[tabKey].settingsData = lockedSettings;
        }
        return;
      }


      const setting = settings.find((s) => s.type === type);


      let existingSettings = [];
      if (type === "Voting" && value === "false") {
        existingSettings = settings.filter((s) => s.type !== "ShareVotes" && s.type !== type)
      } else {
        existingSettings = settings.filter((s) => s.type !== type);
      }
      if (selectedTab === "ContentSecurity") {
        if (type === "CipherPattern" && value !== "2") {
          existingSettings = settings.filter((s) => s.type !== "Shape" && s.type !== type)
        } else {
          existingSettings = settings.filter((s) => s.type !== type)
        }

      }

      let updatedShareVoteSettings = {};
      let updatedShapeSettings = {};
      if (type === "Voting" && value === "false") {
        const shareVotesSetting = settings.find((s) => s.type === "ShareVotes");
        updatedShareVoteSettings = { ...shareVotesSetting };
        updatedShareVoteSettings = {
          ...updatedShareVoteSettings,
          keyValue: value,
          [selectedTab === "DirectSendDefaults" ? "isOverride" : "overrideUserSetting"]: value,
          [selectedTab === "DirectSendDefaults" ? "isLock" : "lockSetting"]: value,
          isDataChanged: (
            (shareVotesSetting?.prevValue !== value) ||
            (shareVotesSetting?.prevOverride !== isOverride) ||
            (shareVotesSetting?.prevLock !== isLock)
          )
        };
      }

      if (selectedTab === "ContentSecurity") {
        if (type === "CipherPattern" && value !== "2") {
          const shapeSetting = settings.find((s) => s.type === "Shape");
          updatedShapeSettings = { ...shapeSetting };
          updatedShapeSettings = {
            ...updatedShapeSettings,
            keyValue: "0",
            [selectedTab === "ContentSecurity" ? "isOverride" : "overrideUserSetting"]: "false",
            [selectedTab === "ContentSecurity" ? "isLock" : "lockSetting"]: "false",
            isDataChanged: (
              (shapeSetting?.prevValue !== "0") ||
              (shapeSetting?.prevOverride !== "false") ||
              (shapeSetting?.prevLock !== "false")
            )
          };
        }
      }

      let updatedSettings = { ...setting };

      if (securityLevel && securityLevel !== "") {
        updatedSettings = {
          ...updatedSettings,
          keyCollection: [...setting.keyCollection?.map((item) => {
            if (item.level === securityLevel) {
              return {
                ...item,
                levelFlag: value === "true",
              };
            }
            return { ...item };
          })],
          ...(setting?.keyCollection?.length === 0 || setting?.keyCollection?.find(k => k.level === securityLevel)?.levelFlag !== value && {
            isDataChanged: true,
          }),
          ...(setting?.keyCollection?.length > 0 && setting?.keyCollection?.find(k => k.level === securityLevel)?.levelFlag === value && {
            isDataChanged: false,
          }),

        };
        state[tabKey].settingsData = [
          { ...updatedSettings },
          ...existingSettings,
        ];
        return;
      }


      if (outerTabSelected === "Company" || outerTabSelected === "Admin") {
        if (isOverride && isOverride !== "") {
          updatedSettings = {
            ...updatedSettings,
            [(selectedTab === "DirectSendDefaults" || selectedTab === "ContentSecurity" || selectedTab === "ExcelSupport") ? "isOverride" : "overrideUserSetting"]: isOverride,
            ...(setting?.prevOverride !== isOverride && {
              isDataChanged: true,
            }),
            ...(setting?.prevOverride === isOverride && {
              isDataChanged: false,
            }),

          };
        } else if (isLock && isLock !== "") {
          updatedSettings = {
            ...updatedSettings,
            [(selectedTab === "DirectSendDefaults" || selectedTab === "ContentSecurity" || selectedTab === "ExcelSupport") ? "isLock" : "lockSetting"]: isLock,
            ...(setting?.prevLock !== isLock && {
              isDataChanged: true,
            }),
            ...(setting?.prevLock === isLock && {
              isDataChanged: false,
            }),

          };
        } else {
          const currentOverride = setting[(selectedTab === "DirectSendDefaults" || selectedTab === "ContentSecurity" || selectedTab === "ExcelSupport") ? "isOverride" : "overrideUserSetting"];
          const currentLock = setting[(selectedTab === "DirectSendDefaults" || selectedTab === "ContentSecurity" || selectedTab === "ExcelSupport") ? "isLock" : "lockSetting"];

          updatedSettings = {
            ...updatedSettings,
            keyValue: value,
            isDataChanged: (
              (setting?.prevValue !== value) ||
              (setting?.prevOverride !== currentOverride) ||
              (setting?.prevLock !== currentLock)
            )
          };
        }
      } else {
        updatedSettings = {
          ...updatedSettings,
          keyValue: value,
          ...(setting?.prevValue !== value && {
            isDataChanged: true,
          }),
          ...(setting?.prevValue === value && {
            isDataChanged: false,
          }),
        };
      }




      if (type === "Voting" && value === "false") {
        let updatedVotingSettings = [{ ...updatedSettings }, { ...updatedShareVoteSettings }];
        //updatedSettings = [...updatedVotingSettings];
        if (selectedTab === "DirectSendDefaults") {
          state[tabKey].settingsData.find(s => s.settingFor === state.defaultSetting)[targetLevel] = [
            ...updatedVotingSettings,
            ...existingSettings,
          ]
        } else {
          state[tabKey].settingsData = [
            ...updatedVotingSettings,
            ...existingSettings,
          ]
        }
      } else if (selectedTab === "ContentSecurity" && type === "CipherPattern" && value !== "2") {
        let updatedContentSettings = [{ ...updatedSettings }, { ...updatedShapeSettings }];
        //updatedSettings = [...updatedContentSettings];
        state[tabKey].settingsData[0][targetLevel] = [
          ...updatedContentSettings,
          ...existingSettings,
        ]
      }
      else {
        if (selectedTab === "DirectSendDefaults") {
          state[tabKey].settingsData.find(s => s.settingFor === state.defaultSetting)[targetLevel] = [
            { ...updatedSettings },
            ...existingSettings,
          ];
        } else if (selectedTab === "ContentSecurity") {
          state[tabKey].settingsData[0][targetLevel] = [
            { ...updatedSettings },
            ...existingSettings,
          ];
        } else {
          state[tabKey].settingsData = [
            { ...updatedSettings },
            ...existingSettings,
          ];
        }
      }
      return;
    },


    updateUserSettings(state, action) {
      const { value, id } = action.payload;
      const tabMap = {
        'Personal': 'personalTab',
        'Company': 'companyTab',
        'Admin': 'AdminTab'
      };

      const tabKey = tabMap[state.settingFor];
      const settings = [...state[tabKey].settingsData];
      const setting = settings.find((s) => s.id === id);
      const index = settings.findIndex((s) => s.id === id);
      const updatedSettings = {
        ...setting,
        roleID: value,
        ...(setting?.prevValue !== value && {
          isDataChanged: true,
        }),
        ...(setting?.prevValue === value && {
          isDataChanged: false,
        }),
      };
      settings[index] = updatedSettings;
      state[tabKey].settingsData = settings;
      return;
    },

    validateInput(state, action) {
      state.inValidInputs = { ip: action.payload.value }
    },
    excludeControls(state, action) {
      state.excludeControls = [];
      const values = Array.isArray(action.payload.value) ? action.payload.value : [action.payload.value];
      values.forEach(value => {
        if (!state.excludeControls.includes(value)) {
          state.excludeControls.push(value);
        }
      });
    },

    setSearchedUserName(state, action) {
      const { searchText, companyName } = action.payload;
      state.searchedUser = searchText;
      state.searchedCompany = companyName;
    },

    setSettingFor(state, action) {
      state.settingFor = action.payload;
      state.searchedUser = "";
    },

    storeLookupData(state, action) {
      state.lookupData = action.payload;
    },
    setDefaultSettingsFor(state, action) {
      state.defaultSetting = action.payload.value;
    },

    restoreDefaults(state, action) {
      state.restoreDefaults.cipher = false;
      state.restoreDefaults.floating = false;
      state.restoreDefaults.l1 = false;
      state.restoreDefaults.l2 = false;
      state.restoreDefaults.l3 = false;
    }

  }
})


export const { languageChange } = languageSlice.actions;

export const currentSelectedLanguage = (state) => state.counter;
export const { retainConfiguredData, removeConfiguredData } =
  pageLevelRestrictionSlice.actions;
export const { retainTimeZoneData, removeTimeZoneData } = timeZoneSlice.actions;
export const { setIDLeakersType, clearIDLeakersType } = idLeakersSlice.actions;
export const { setDocumentTemplates, clearDocumentTemplates } = DocumentTemplatesSlice.actions;
export const { setCustomFilterOptions, clearCustomFilterOptions } = CustomFilterOptionsSlice.actions;
export const { setDocumentTemplateName, clearDocumentTemplateName } = DocumentTemplateNameSlice.actions;

export const { sethandleTabValues } = handleTabValuesSlice.actions;

export const { storeLookupData, storeSettingsData, validateInput, setSettingFor, updateSettingsData, updateUserSettings, setSearchedUserName, setDefaultSettingsFor, excludeControls, restoreDefaults } = SettingsSlice.actions;

export const { storeIdentifyLeakers, storeIDLeakerLookupData, updateIDLeakerValue, resetIdentifyLeakers } = IdentifyLeakerSlice.actions;
export const { storeTemplateIdentifyLeakers, storeTemplateIDLeakerLookupData, updateTemplateIDLeakerValue, resetTemplateIdentifyLeakers } = TemplateIdentifyLeakerSlice.actions;
export default languageSlice.reducer;
